export const AvailabilitySearchType = {
  default: 0,
  allotment: 1,
};
